import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';

export const addIngredient = (name) => {
    return {
        type: actionTypes.ADD_INGRIDIENT,
        ingredientName: name
    }
}

export const removeIngredient = (name) => {
    return {
        type: actionTypes.REMOVE_INGRIDIENT,
        ingredientName: name
    }
}

export const setIngridients = ( ingridients ) => {
    return {
        type: actionTypes.SET_INGRIDIENTS,
        ingridients: ingridients
    }
};

export const fetchIngridientsFailed = () => {
    return {
        type: actionTypes.FETCH_INGRIDIENTS_FAILED 
    }
};

export const initIngridients = () => {
    return dispatch => {
        axios.get('https://react-burger-builder-d26ba.firebaseio.com/ingredients.json')
        .then((response) => {
            dispatch( setIngridients( response.data ) )
        })
        .catch((error) => {
            dispatch( fetchIngridientsFailed() )
        });
    };
};